import React, { useContext } from 'react'
import {
  MedPlanContext,
  OpsPlanContext,
  RiskAssessmentContext,
} from '../SingleEvent'
import { Box, Stack, Typography, styled } from '@mui/material'
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress'

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
  },
}))

const ProgressBar = ({ value, label }) => {
  return (
    <Stack>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '100%', mr: 1 }}>
          <BorderLinearProgress
            value={Math.min(value, 100)}
            variant="determinate"
          />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="text.secondary">{`${Math.round(
            Math.min(value, 100)
          )}%`}</Typography>
        </Box>
      </Box>
      <Typography variant="caption">{label}</Typography>
    </Stack>
  )
}

const PlanningCompletion = () => {
  const { opsPlan } = useContext(OpsPlanContext)
  const { riskAssessment } = useContext(RiskAssessmentContext)
  const { medPlan } = useContext(MedPlanContext)

  const _opsPlanTotalFields = 10
  const _riskAssessTotalFields = 28
  const _clinicalPlanTotalFields = 12

  const opsPlanPercent =
    (Object.values(opsPlan ?? []).length / _opsPlanTotalFields) * 100
  const riskAssessPercent =
    (Object.values(riskAssessment ?? []).length / _riskAssessTotalFields) * 100
  const clinicalPlanPercent =
    (Object.keys(medPlan ?? []).length / _clinicalPlanTotalFields) * 100

  return (
    <Stack gap={1}>
      <Typography variant="title3">Planning Progress</Typography>
      <ProgressBar value={opsPlanPercent} label="Ops Plan" />
      <ProgressBar value={riskAssessPercent} label="Risk Assessment" />
      <ProgressBar value={clinicalPlanPercent} label="Clinical Plan" />
    </Stack>
  )
}

export default PlanningCompletion
